export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/beauty_fashion.06d100f.svg";